<template>
  <div v-if="device" class="md-layout md-gutter">
    <div class="md-layout-item md-size-100 md-small-size-100">
      <div class="md-layout-item md-size-100">
        <DeviceEditCard :device="device"/>
      </div>
    </div>
  </div>
</template>

<script>
import DeviceEditCard from "@/pages/Dashboard/Devices/Edit/Form/DeviceEditCard.vue";
import globalId from "@/mixins/global-id";

export default {
  name: "EditDevice",
  data: () => ({
    device: null,
  }),
  components: {
    DeviceEditCard,
  },
  mixins: [globalId],
  created() {
    this.getDevice();
  },
  methods: {
    async getDevice() {
      try {
        await this.$store.dispatch("devices/get", this.globalDecode(this.$route.params.deviceId));

        this.device = await this.$store.getters["devices/device"]

      } catch (e) {
        await this.$store.dispatch("alerts/error", `Oops, ${e.message}`)
        this.setApiValidation(e.response.data.errors)
      }
    }
  }
}
</script>

